var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCensusActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_898_135772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4043 23.4009C29.5166 23.5124 29.5926 23.6539 29.6229 23.8078C29.6532 23.9616 29.6362 24.1207 29.5742 24.2651C29.5135 24.4099 29.4104 24.5338 29.2779 24.6213C29.1453 24.7087 28.9894 24.7559 28.8296 24.7566H13.4502V10.4852H28.8296C28.9893 10.486 29.1453 10.5331 29.2779 10.6206C29.4104 10.7081 29.5135 10.832 29.5742 10.9768C29.6362 11.1212 29.6532 11.2803 29.6229 11.4341C29.5926 11.588 29.5166 11.7295 29.4043 11.841L23.4953 17.6211L29.4043 23.4009ZM11.022 8.89941C10.8073 8.89941 10.6014 8.98291 10.4496 9.13165C10.2978 9.28031 10.2125 9.48198 10.2125 9.69227V30.3065C10.2125 30.5898 10.3668 30.8515 10.6172 30.9932C10.8677 31.1348 11.1763 31.1348 11.4267 30.9932C11.6771 30.8515 11.8314 30.5898 11.8314 30.3065V9.69227C11.8314 9.482 11.7462 9.28032 11.5943 9.13165C11.4425 8.9829 11.2367 8.89941 11.022 8.89941Z",
    fill: "#A30001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_898_135772",
    x: -2,
    y: -1,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_898_135772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_898_135772",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCensusActive);
export default __webpack_public_path__ + "static/media/CensusActive.ff466dd988ffb374373700662f8a8034.svg";
export { ForwardRef as ReactComponent };